import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import StarIcon from '@mui/icons-material/Star';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import Sorting, { useSorting } from 'components/Sorting';
import Table from 'components/Table';
import TableCell from 'components/TableCell';
import ServiceEditVariantsRow from 'components/ServiceEditVariantsRow';
import FabDialog from 'components/FabDialog';
import AddServiceOptionDialog from 'components/AddServiceOptionDialog';

import { useDelete } from 'lib';
import { ServiceGroupEditServicesSortMutation } from '__generated__/ServiceGroupEditServicesSortMutation.graphql';
import { ServiceEditVariants_service$key } from '__generated__/ServiceEditVariants_service.graphql';

type Props = {
  service: ServiceEditVariants_service$key;
};

const ServiceEditVariants: FC<Props> = props => {
  const service = useFragment(
    graphql`
      fragment ServiceEditVariants_service on Service {
        options(first: 2147483647) {
          __id
          edges {
            node {
              id

              ...ServiceEditVariantsRow_serviceOption
            }
          }

          pageInfo {
            ...Table_pageInfo
          }
        }

        ...AddServiceOptionDialog_service
      }
    `,
    props.service
  );

  const connectionId = service.options?.__id;

  const [sort, sorting] = useSorting<ServiceGroupEditServicesSortMutation>(
    graphql`
      mutation ServiceEditVariantsSortMutation(
        $positions: [EntityWithPositionInput!]!
      ) {
        updateServiceOptionPositions(positions: $positions)
      }
    `,
    connectionId
  );

  const [deleteRegion, deleting] = useDelete(connectionId);

  const { edges, pageInfo } = service.options ?? {};

  if (!edges) return null;

  return (
    <Paper sx={{ p: 2 }}>
      <Sorting edges={edges} onSort={sort}>
        <Table
          pagination
          pageInfo={pageInfo ?? null}
          icon={<StarIcon />}
          loading={deleting || sorting}
          head={
            <TableRow>
              <TableCell />
              <TableCell>Pavadinimas</TableCell>
              <TableCell center>Scoro produkto ID</TableCell>
              <TableCell center>Kaina</TableCell>
              <TableCell />
            </TableRow>
          }>
          {edges?.map(({ node }) => (
            <ServiceEditVariantsRow
              key={node.id}
              serviceOption={node}
              onDelete={deleteRegion}
            />
          ))}
        </Table>
      </Sorting>

      {connectionId && (
        <FabDialog fullWidth maxWidth="sm">
          <AddServiceOptionDialog
            connectionId={connectionId}
            service={service}
          />
        </FabDialog>
      )}
    </Paper>
  );
};

export default ServiceEditVariants;
